import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, Input, PLATFORM_ID } from '@angular/core';
import { CollectiviteitData } from '@inshared/shared/core';
import { SessionStorageService } from '@inshared/shared/util-storage';
import { AuthenticationDataService } from 'outshared-lib';
import { Observable } from 'rxjs';

@Component({
    selector: 'ins-topbar-container',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <ins-topbar
            [collectivity]="collectivity"
            [authenticated]="authenticated$ | async"
            [useAngularRouter]="useAngularRouter"
        >
        </ins-topbar>
    `,
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class TopbarContainer {
    @Input() public useAngularRouter: boolean = false;

    public authenticated$: Observable<boolean> = this.authenticationDataService.isLoggedIn$();
    public collectivity: CollectiviteitData | null = null;

    constructor(
        private authenticationDataService: AuthenticationDataService,
        @Inject(PLATFORM_ID) platformId: object,
        @Inject(SessionStorageService) private sessionStorage: Storage
    ) {
        if (isPlatformBrowser(platformId)) {
            this.getCollectivity();
        }
    }

    private getCollectivity() {
        const collectivity = this.sessionStorage.getItem('collectiviteit');

        if (collectivity) {
            this.collectivity = JSON.parse(collectivity);
        }
    }
}
